import axios from "axios";
import { getConfig } from "../config/app.config";
import { ConfigKey } from "../enum/ConfigKey";
import { isEmbeddedMode } from "../util/embedded";

const api = axios.create({
  baseURL: getConfig(ConfigKey.REACT_APP_BACKEND_API_URL),
  // Enable sending cookies with requests only in embedded mode
  // This allows the backend to read cookies if needed as fallback
  // In normal mode, we rely on Authorization header only
  withCredentials: isEmbeddedMode(),
});

export default api;
